import { gbp, localizeText } from "@/lib/format";
import { Sparkles, PiggyBank, Clock } from "lucide-react";

export default function SavingsNudges({ data }) {
  const suggestions = data?.suggestions || [];
  const hasData = data?.has_enough_data;

  return (
    <div className="mm-glow-card p-6" data-testid="savings-nudges">
      <div className="flex items-center gap-2.5">
        <span className="h-10 w-10 rounded-xl bg-[#00C896]/15 flex items-center justify-center text-[#00C896]">
          <Sparkles className="h-5 w-5" />
        </span>
        <div>
          <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#00C896]">Money saver</p>
          <h3 className="font-display text-lg font-semibold">Gentle ways to save</h3>
        </div>
      </div>

      {!hasData ? (
        <div data-testid="nudges-empty" className="mt-5 rounded-xl border border-dashed border-white/12 p-8 text-center">
          <Clock className="h-6 w-6 text-slate-500 mx-auto" />
          <p className="text-sm text-slate-400 mt-3">{data?.empty_message || "We're still getting to know your spending — check back soon."}</p>
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
          {suggestions.map((s) => (
            <div key={s.key} data-testid={`nudge-${s.key}`} className="rounded-xl border border-white/8 bg-[#0D0D0D] p-4 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full" style={{ background: s.accent }} />
                <h4 className="font-display font-semibold">{localizeText(s.title)}</h4>
              </div>
              <p className="text-sm text-slate-300 leading-relaxed mt-2 flex-1">{localizeText(s.message)}</p>
              <div className="mt-3 grid grid-cols-2 gap-2">
                <div className="rounded-lg bg-black/30 border border-white/6 px-3 py-2">
                  <p className="text-[10px] text-slate-500">Last 30 days</p>
                  <p className="font-num text-sm font-semibold mt-0.5">{gbp(s.spend_30d)}</p>
                </div>
                <div className="rounded-lg bg-[#00C896]/10 border border-[#00C896]/20 px-3 py-2">
                  <p className="text-[10px] text-[#4DE3BF] flex items-center gap-1"><PiggyBank className="h-3 w-3" /> Could save / mo</p>
                  <p className="font-num text-sm font-semibold text-[#00C896] mt-0.5">{gbp(s.saving)}</p>
                </div>
              </div>
              {s.merchants?.length > 0 && (
                <p className="text-[11px] text-slate-500 mt-2 truncate">Seen at {s.merchants.join(", ")}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
